{
  "slide-1-after": {
    "h": 480,
    "v": [
      400,
      640,
      800
    ],
    "w": 800
  },
  "slide-1-before": {
    "h": 480,
    "v": [
      400,
      640,
      800
    ],
    "w": 800
  },
  "slide-10-after": {
    "h": 1000,
    "v": [
      400,
      640,
      800
    ],
    "w": 800
  },
  "slide-10-before": {
    "h": 900,
    "v": [
      400,
      640,
      720
    ],
    "w": 720
  },
  "slide-11-after": {
    "h": 732,
    "v": [
      400,
      640,
      800
    ],
    "w": 800
  },
  "slide-11-before": {
    "h": 894,
    "v": [
      400,
      640,
      800
    ],
    "w": 800
  },
  "slide-12-after": {
    "h": 328,
    "v": [
      400,
      486
    ],
    "w": 486
  },
  "slide-12-before": {
    "h": 328,
    "v": [
      400,
      486
    ],
    "w": 486
  },
  "slide-13": {
    "h": 513,
    "v": [
      400,
      640,
      800
    ],
    "w": 800
  },
  "slide-13-before": {
    "h": 551,
    "v": [
      400,
      420
    ],
    "w": 420
  },
  "slide-14-after": {
    "h": 543,
    "v": [
      400,
      444
    ],
    "w": 444
  },
  "slide-14-before": {
    "h": 543,
    "v": [
      400,
      444
    ],
    "w": 444
  },
  "slide-15-after": {
    "h": 627,
    "v": [
      400,
      640
    ],
    "w": 640
  },
  "slide-15-before": {
    "h": 627,
    "v": [
      400,
      640
    ],
    "w": 640
  },
  "slide-16-after": {
    "h": 907,
    "v": [
      400,
      640,
      794
    ],
    "w": 794
  },
  "slide-16-before": {
    "h": 631,
    "v": [
      400,
      640
    ],
    "w": 640
  },
  "slide-17-after": {
    "h": 534,
    "v": [
      400,
      640,
      800
    ],
    "w": 800
  },
  "slide-17-before": {
    "h": 600,
    "v": [
      400,
      640,
      800
    ],
    "w": 800
  },
  "slide-18-after": {
    "h": 960,
    "v": [
      400,
      528
    ],
    "w": 528
  },
  "slide-18-before": {
    "h": 960,
    "v": [
      400,
      540
    ],
    "w": 540
  },
  "slide-19-after": {
    "h": 771,
    "v": [
      400,
      640,
      800
    ],
    "w": 800
  },
  "slide-19-before": {
    "h": 717,
    "v": [
      400,
      462
    ],
    "w": 462
  },
  "slide-2-after": {
    "h": 480,
    "v": [
      400,
      640,
      800
    ],
    "w": 800
  },
  "slide-2-before": {
    "h": 480,
    "v": [
      400,
      640,
      800
    ],
    "w": 800
  },
  "slide-20-after": {
    "h": 940,
    "v": [
      400,
      640,
      800
    ],
    "w": 800
  },
  "slide-20-before": {
    "h": 655,
    "v": [
      400,
      640,
      800
    ],
    "w": 800
  },
  "slide-21-after": {
    "h": 742,
    "v": [
      371
    ],
    "w": 371
  },
  "slide-21-before": {
    "h": 742,
    "v": [
      371
    ],
    "w": 371
  },
  "slide-22-after": {
    "h": 1564,
    "v": [
      400,
      640,
      782
    ],
    "w": 782
  },
  "slide-22-before": {
    "h": 1564,
    "v": [
      400,
      640,
      782
    ],
    "w": 782
  },
  "slide-23-after": {
    "h": 1095,
    "v": [
      400,
      640,
      800
    ],
    "w": 800
  },
  "slide-23-before": {
    "h": 1414,
    "v": [
      400,
      640,
      800
    ],
    "w": 800
  },
  "slide-24-after": {
    "h": 640,
    "v": [
      320
    ],
    "w": 320
  },
  "slide-24-before": {
    "h": 640,
    "v": [
      320
    ],
    "w": 320
  },
  "slide-25-after": {
    "h": 525,
    "v": [
      400,
      640,
      700
    ],
    "w": 700
  },
  "slide-25-before": {
    "h": 399,
    "v": [
      283
    ],
    "w": 283
  },
  "slide-26-after": {
    "h": 720,
    "v": [
      400
    ],
    "w": 400
  },
  "slide-26-before": {
    "h": 423,
    "v": [
      316
    ],
    "w": 316
  },
  "slide-27-after": {
    "h": 475,
    "v": [
      319
    ],
    "w": 319
  },
  "slide-27-before": {
    "h": 768,
    "v": [
      400,
      563
    ],
    "w": 563
  },
  "slide-28-after": {
    "h": 313,
    "v": [
      192
    ],
    "w": 192
  },
  "slide-28-before": {
    "h": 313,
    "v": [
      192
    ],
    "w": 192
  },
  "slide-29": {
    "h": 577,
    "v": [
      400,
      800
    ],
    "w": 800
  },
  "slide-3-after": {
    "h": 480,
    "v": [
      400,
      640,
      800
    ],
    "w": 800
  },
  "slide-3-before": {
    "h": 480,
    "v": [
      400,
      640,
      800
    ],
    "w": 800
  },
  "slide-30": {
    "h": 800,
    "v": [
      400,
      640,
      800
    ],
    "w": 800
  },
  "slide-31": {
    "h": 960,
    "v": [
      400,
      640,
      800
    ],
    "w": 960
  },
  "slide-32": {
    "h": 900,
    "v": [
      400,
      640,
      800
    ],
    "w": 900
  },
  "slide-33-after": {
    "h": 1586,
    "v": [
      400,
      640,
      800
    ],
    "w": 800
  },
  "slide-33-before": {
    "h": 1280,
    "v": [
      400,
      591
    ],
    "w": 591
  },
  "slide-4-after": {
    "h": 480,
    "v": [
      400,
      640,
      800
    ],
    "w": 800
  },
  "slide-4-before": {
    "h": 480,
    "v": [
      400,
      640,
      800
    ],
    "w": 800
  },
  "slide-5-after": {
    "h": 480,
    "v": [
      400,
      640,
      800
    ],
    "w": 800
  },
  "slide-5-before": {
    "h": 480,
    "v": [
      400,
      640,
      800
    ],
    "w": 800
  },
  "slide-6-after": {
    "h": 1589,
    "v": [
      400,
      640,
      800
    ],
    "w": 800
  },
  "slide-6-before": {
    "h": 640,
    "v": [
      400,
      480
    ],
    "w": 480
  },
  "slide-7-after": {
    "h": 528,
    "v": [
      400,
      495
    ],
    "w": 495
  },
  "slide-7-before": {
    "h": 528,
    "v": [
      400,
      495
    ],
    "w": 495
  },
  "slide-8-after": {
    "h": 1440,
    "v": [
      400,
      640,
      720
    ],
    "w": 720
  },
  "slide-8-before": {
    "h": 1440,
    "v": [
      400,
      640,
      720
    ],
    "w": 720
  },
  "slide-9-after": {
    "h": 477,
    "v": [
      400,
      640
    ],
    "w": 640
  },
  "slide-9-before": {
    "h": 1057,
    "v": [
      400,
      640
    ],
    "w": 640
  }
}
